import React from 'react';

import { Route, Switch } from 'react-router-dom';
import { selectHasContentFeature } from '~/organizations/selectors';
import { contentPage } from '~/routes';
import { useAppSelector } from '~/store';
import Content from './Content';
import { UpgradePath } from '../UpgradePath';

/**
 * Wraps the Content component in a PlateProvider with Ideas ID.
 * The Provider is needed for Plate state context to be available below this point.
 * This allows us to use Plate hooks.
 */
export const ContentApp = () => {
  const hasContentFeature = useAppSelector(selectHasContentFeature);

  return (
    <Switch>
      <Route
        path={contentPage.route}
        component={hasContentFeature ? Content : UpgradePath}
      />
    </Switch>
  );
};
